import { useMemo } from 'react'

import { ModalContext } from '@domain-group/suit-theme'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContext from '@contexts/pageContext'

import BulkRemapCampaignPortalsModal from '@modals/BulkRemapCampaignPortalsModal'

import PageContent from './components/PageContent'

type DefaultState = {
  showBulkRemapCampaignPortalsModal: boolean,
}

const defaultState = {
  showBulkRemapCampaignPortalsModal: false,
}

const callbacks = (component: keyof typeof componentCallbacks, setState: (state: Partial<DefaultState>) => void) => {
  const componentCallbacks = {
    BulkRemapCampaignPortalsModal: {
      closeModal: () => setState({ showBulkRemapCampaignPortalsModal: false }),
      bulkPortalRemap: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const {
    showBulkRemapCampaignPortalsModal,
  } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showBulkRemapCampaignPortalsModal: (payload: object) => {
        setModalData('BulkRemapCampaignPortalsModal', payload)
        setState({ showBulkRemapCampaignPortalsModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <BulkRemapCampaignPortalsModal
          // @ts-expect-error TS2322
          callbacks={callbacks('BulkRemapCampaignPortalsModal', setState)}
          showModal={showBulkRemapCampaignPortalsModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
